




























import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../domain";
import { EntryTypes } from "../../domain/account";

@Component({
  components: {
  },
})
export default class RegisterNewAccountView extends Mixins() {
  data() {
    return {
      isProcessing: false,
      accountCode: "",
      password: "",
      passwordForVerify: "",
    };
  }
  isProcessing: boolean;
  accountCode: string;
  password: string;
  passwordForVerify: string;

  @Prop()
  entryGuid: string;

  async created(): Promise<void> {
    this.isProcessing = true;
    try {
      if (!this.entryGuid) { throw new Error("entryGuid is empty!!!"); }
      const repo = DomainRegistry.account.getUnauthenticatedAccountRepository();
      const entry = await repo.getAccountEntry(this.entryGuid, EntryTypes.RegisterNewAccount);
      if (entry.isExpired) {
        this.$error("アカウント登録", "アカウント登録要求の有効期限が切れています。");
        return;
      }
      this.accountCode = entry.accountCode;
    } catch (e) {
      this.$error("アカウント登録", "アカウント登録要求の取得に失敗しました。", e);
    } finally {
      this.isProcessing = false;
    }
  }

  async register(): Promise<void> {
    if (!this.accountCode) {
      this.$warn("アカウント登録", "ログインID（メールアドレス）の取得に失敗しています。");
      return;
    }
    if (!this.password) {
      this.$warn("アカウント登録", "パスワードを入力してください。");
      return;
    }
    if (!this.passwordForVerify) {
      this.$warn("アカウント登録", "パスワード（確認用）を入力してください。");
      return;
    }
    if (this.password !== this.passwordForVerify) {
      this.$warn("アカウント登録", "パスワードが確認用に入力したものと異なっています。");
      return;
    }

    this.isProcessing = true;
    try {
      const repo = DomainRegistry.account.getUnauthenticatedAccountRepository();
      const result = await repo.registerNewAccount(this.entryGuid, this.accountCode, this.password);
      if (result.isExpired) {
        this.$warn("アカウント登録", "処理の有効期限が切れているため、登録できません。");
        return;
      }
      if (result.isAlreadyRegistered) {
        this.$warn("アカウント登録", "すでに登録されているIDのため、登録できません。");
        return;
      }
      if (!result.isOk) {
        this.$warn("アカウント登録", "アカウント登録できませんでした。");
        return;
      }
      this.$success("アカウント登録", "新規アカウントを登録しました。");
      // TODO: 登録成功したらログインまで済ませて画面を遷移したほうがよい？
      this.$router.replace({
        path: "/Login",
        query: {
          defaultAccountCode: this.accountCode,
        },
      });
    } catch (e) {
      this.$error("アカウント登録", "アカウント登録処理中にエラーが発生しました。", e);
    } finally {
      this.isProcessing = false;
    }
  }

  moveToLoginView(): void {
    this.$router.replace({
      path: "/Login",
    });
  }
}
